'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createLoginClient;

var _swaggerClient = require('swagger-client');

var _swaggerClient2 = _interopRequireDefault(_swaggerClient);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createLoginClient() {
  var swaggerUrl = (_config2.default.isSecured ? 'https://' : 'http://') + _config2.default.apiProxyUrl + '/swagger.json';
  var swaggerResponse = new _swaggerClient2.default({
    url: swaggerUrl,
    // url: 'http://fluent-td-agent-dev-01-976180400.us-east-1.elb.amazonaws.com:40002/api/swagger.json',
    // url: 'http://10.250.143.62:8083/api/swagger.json',
    // url: 'http://mtl4ehou-pc:8083/api/swagger.json',
    usePromise: true
  });
  swaggerResponse.catch(function (error) {
    console.error('swagger ' + swaggerUrl + ' return an error : ' + error);
  });

  return swaggerResponse;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/createLoginClient.js
// module id = 98
// module chunks = 0